export const EVENT_NAMES = {
  pageLoad: 'page_loaded',
  GA: 'GAEvent',
};
